import { render, staticRenderFns } from "./ImgPreviewModal.vue?vue&type=template&id=06aa4da1&scoped=true"
import script from "./ImgPreviewModal.vue?vue&type=script&lang=js"
export * from "./ImgPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./ImgPreviewModal.vue?vue&type=style&index=0&id=06aa4da1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aa4da1",
  null
  
)

export default component.exports